import React from 'react';
import { COPY } from '../presentationCopy';
import Pill from './Pill';

const ProductKindMark: React.FC = () => (
  <Pill tone="info" title={COPY.pageKindProductHint}>
    {COPY.pageKindProduct}
  </Pill>
);

export default ProductKindMark;
